module.exports = __webpack_public_path__ + "img/01.43af9b28.jpg";